import React from 'react';
import { useHistory, useLocation } from 'react-router-dom';

import { ReactComponent as LogOutIcon } from '../../img/svg/Actions/Logout.svg';
import { successMsg } from '../../config';

const restrictedRoutes = [
  '',
  'StakeHub',
  'MarketHub',
  'AboutUs',
  'AboutBucks',
  'MissionNFT',
  'FaqGlossary',
  'MintingGuidelines',
  'StarStakeGuidelines',
  'HowItWorks',
  'ComingSoon',
  'ForCreators',
  'ForFans'
];
function ManagerStarLoginInfo({ starData = {}, updateStarData = () => {} }) {
  const history = useHistory();
  const { pathname } = useLocation();

  const handleLogout = () => {
    updateStarData(null, null, null);
    successMsg('Logged Out as Brand!');
  };

  React.useEffect(() => {
    if (!starData.starName || !starData.starId) return;
    if (restrictedRoutes.includes(pathname.split('/')[1])) handleLogout();
  }, [pathname]);

  if (!starData || !starData.starName || !starData.starId) return null;

  return (
    <div className="manager-access-noti w-100">
      <span className="blink">
        * Logged in as Brand: {starData.starName} ({starData.starId})
      </span>
      <span
        className="manager-login-star-text"
        onClick={() => {
          handleLogout();
          return history.push('/StakeHub/Manager/MyStars');
        }}
      >
        <LogOutIcon />
        Logout
      </span>
    </div>
  );
}

export default ManagerStarLoginInfo;
